/**
 * Typography CSS Generator
 *
 * Function for generating complete CSS from typography attributes using responsive utilities
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { generateResponsiveCSS } from '../../common/responsive';
import type { TypographyAttributes, TypographyValues } from '../types';
import { generateTypographyCSSRules } from './rules';

/**
 * Generate complete responsive CSS for typography control group
 */
export const getTypographyCSS = (
	attributes: TypographyAttributes,
	selector: string = '',
): string => {
	return generateResponsiveCSS< TypographyValues >(
		attributes,
		selector,
		generateTypographyCSSRules,
	);
};

// Re-export the rules function for direct access
export { generateTypographyCSSRules } from './rules';
